import { render, staticRenderFns } from "./SumplingFrozen.vue?vue&type=template&id=2043cbab"
import script from "./SumplingFrozen.vue?vue&type=script&lang=js"
export * from "./SumplingFrozen.vue?vue&type=script&lang=js"
import style0 from "./SumplingFrozen.vue?vue&type=style&index=0&id=2043cbab&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports